import amplitudeSvg from './amplitude.svg';
import atlasGoalSvg from './atlas_goal.svg';
import atlasProjectSvg from './atlas_project.svg';
import atlassianWebCrawlerSvg from './atlassian-web-crawler.svg';
import bitbucketSvg from './bitbucket.svg';
import compassSvg from './compass.svg';
import confluenceSvg from './confluence.svg';
import databricksSvg from './databricks.svg';
import githubSvg from './github.svg';
import googleCalendarSvg from './google_calendar.svg';
import googleDriveSvg from './google_drive.svg';
import helpAggregatorSvg from './help_aggregator.svg';
import jiraSvg from './jira.svg';
import lucidSvg from './lucid.svg';
import microsoftOnedriveSvg from './microsoft_onedrive.svg';
import microsoftPowerBiSvg from './microsoft_power_bi.svg';
import microsoftSharepointSvg from './microsoft_sharepoint.svg';
import miroSvg from './miro.svg';
import salesforceSvg from './salesforce.svg';
import slackSvg from './slack.svg';
import teamsSvg from './teams.svg';
import todoistSvg from './todoist.svg';
import trelloSvg from './trello.svg';
import zeplinSvg from './zeplin.svg';

export type ConnectorIcon = {
	name: string;
	friendlyName: string;
	svg: string;
};

/**
 * Array of connector icons with their source name, friendly name, and SVG path.
 */
export const CONNECTOR_ICONS: ConnectorIcon[] = [
	{ name: 'google_drive', friendlyName: 'Google Drive', svg: googleDriveSvg },
	{ name: 'confluence', friendlyName: 'Confluence', svg: confluenceSvg },
	{ name: 'jira', friendlyName: 'Jira', svg: jiraSvg },
	{ name: 'bitbucket', friendlyName: 'Bitbucket', svg: bitbucketSvg },
	{ name: 'compass', friendlyName: 'Compass', svg: compassSvg },
	{ name: 'amplitude', friendlyName: 'Amplitude', svg: amplitudeSvg },
	{ name: 'help_aggregator', friendlyName: 'Atlassian Support Docs', svg: helpAggregatorSvg },
	// { name: 'confluence-dc', friendlyName: 'Confluence Data Center', svg: confluenceDcSvg },
	{ name: 'databricks', friendlyName: 'Databricks', svg: databricksSvg },
	{ name: 'github', friendlyName: 'GitHub', svg: githubSvg },
	{ name: 'atlas_goal', friendlyName: 'Goals', svg: atlasGoalSvg },
	{ name: 'google_calendar', friendlyName: 'Google Calendar', svg: googleCalendarSvg },
	// { name: 'jira_dc', friendlyName: 'Jira Data Center', svg: jiraDcSvg },
	{ name: 'lucid', friendlyName: 'Lucid', svg: lucidSvg },
	{ name: 'microsoft_onedrive', friendlyName: 'Microsoft OneDrive', svg: microsoftOnedriveSvg },
	{ name: 'microsoft_power_bi', friendlyName: 'Microsoft Power BI', svg: microsoftPowerBiSvg },
	{
		name: 'microsoft_sharepoint',
		friendlyName: 'Microsoft SharePoint',
		svg: microsoftSharepointSvg,
	},
	{ name: 'teams', friendlyName: 'Microsoft Teams', svg: teamsSvg },
	{ name: 'miro', friendlyName: 'Miro', svg: miroSvg },
	{ name: 'atlas_project', friendlyName: 'Projects', svg: atlasProjectSvg },
	{ name: 'salesforce', friendlyName: 'Salesforce', svg: salesforceSvg },
	{ name: 'slack', friendlyName: 'Slack', svg: slackSvg },
	{ name: 'todoist', friendlyName: 'Todoist', svg: todoistSvg },
	{ name: 'trello', friendlyName: 'Trello', svg: trelloSvg },
	{ name: 'atlassian-web-crawler', friendlyName: 'Web Pages', svg: atlassianWebCrawlerSvg },
	{ name: 'zeplin', friendlyName: 'Zeplin', svg: zeplinSvg },
];
